var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"application"}},[_c('v-app-bar',{attrs:{"app":"","color":"blue darken-3","dark":""}},[_c('v-toolbar-title',[_vm._v("Manage employees")])],1),_c('v-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }